package com.swetdot.swetgram.ui.design

import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.input.VisualTransformation

internal expect val usesBrowserNativeTextInput: Boolean

@Composable
internal expect fun BrowserNativeTextInput(
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier,
    textStyle: TextStyle,
    enabled: Boolean,
    singleLine: Boolean,
    maxLines: Int,
    keyboardOptions: KeyboardOptions,
    keyboardActions: KeyboardActions,
    visualTransformation: VisualTransformation,
    placeholder: String,
    onFocusChanged: (Boolean) -> Unit,
)

/** Native HTML editing on Web; the existing Compose editor on Android/iOS. */
@Composable
internal fun SwetBasicTextField(
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    textStyle: TextStyle = TextStyle.Default,
    keyboardOptions: KeyboardOptions = KeyboardOptions.Default,
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    singleLine: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    cursorBrush: Brush = SolidColor(Color.Black),
    decorationBox: @Composable (innerTextField: @Composable () -> Unit) -> Unit = { it() },
) {
    if (usesBrowserNativeTextInput) {
        // Keep decoration outside the HTML element so placeholders/actions retain their layout.
        androidx.compose.foundation.layout.Box(modifier) {
            decorationBox {
                BrowserNativeTextInput(
                    value, onValueChange, Modifier, textStyle, enabled, singleLine, maxLines,
                    keyboardOptions, keyboardActions, VisualTransformation.None, "", {},
                )
            }
        }
    } else {
        BasicTextField(
            value = value, onValueChange = onValueChange, modifier = modifier,
            enabled = enabled, textStyle = textStyle, keyboardOptions = keyboardOptions,
            keyboardActions = keyboardActions, singleLine = singleLine, maxLines = maxLines,
            cursorBrush = cursorBrush, decorationBox = decorationBox,
        )
    }
}
